<template>
  <app-page lean>
    <!-- leichter Titel wie die übrigen Seiten; der Export als verschachtelte Karte wie im Dashboard (Kundenwunsch
         13.10.2026: „bitte auch die beiden schnittstellen seiten anpassen“) -->
    <div class="app-page-pad">
      <app-panel nested class="gtfs-panel" icon="fileDown" title="GTFS-Export">
        <div class="gtfs">
          <img
            class="gtfs__img"
            src="/img/undraw/undraw_tourist_map_re_293e.svg"
            alt=""
          />
          <div class="gtfs__main">
            <p class="gtfs__text">Letzte Datenaktualisierung: {{ modificationText }}</p>
            <app-button kind="primary" icon="download" :loading="loading" @click="download"
              >GTFS herunterladen</app-button
            >
          </div>
        </div>
      </app-panel>
    </div>
  </app-page>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { formatDateTime, LEER } from "@/utils/format";

export default {
  data() {
    return {
      loading: false,
      info: {},
    };
  },
  computed: {
    // Zeitpunkt nach R6 („08.10.2026, 11:42“), wenn er als ISO-Zeit lesbar ist, sonst unverändert
    modificationText() {
      const t = this.info ? this.info.modification_time : null;
      if (t === null || t === undefined || t === "") {
        return LEER;
      }
      return moment(t, moment.ISO_8601, true).isValid() ? formatDateTime(t) : String(t);
    },
  },
  methods: {
    async download() {
      this.loading = true;
      try {
        const response = await axios.get(`${this.$store.state.baseUrl}gtfs`, {
          responseType: "arraybuffer",
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        console.log({ url });
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "gtfs.zip");
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async downloadInfo() {
      try {
        const response = await axios.get(`${this.$store.state.baseUrl}gtfs?option=info`);
        this.info = response.data;
      } catch (e) {
        // nothing
      }
    },
  },
  mounted() {
    this.downloadInfo();
  },
};
</script>

<style scoped>
.gtfs-panel {
  max-width: 560px;
}
.gtfs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px 20px;
}
/* Illustration klein und ohne Orange (Spezifikation 4.6.4) */
.gtfs__img {
  flex: none;
  width: 96px;
  height: 96px;
  object-fit: contain;
  filter: grayscale(1);
  opacity: .8;
}
/* Dunkelmodus: gedämpft, damit die weißen Flächen der Illustration nicht grell wirken */
@media screen {
  html.farbschema-dunkel .gtfs__img {
    filter: grayscale(1) brightness(.8);
  }
}
.gtfs__main {
  flex: 1 1 240px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}
p.gtfs__text {
  margin: 0;
  font-size: 13px;
  line-height: 20px;
  color: var(--ink-2);
}
</style>
